
import selectAll from '@/components/jcdc/JcdcSelectAll.vue'
import Vue from 'vue'
import { VAutocomplete, VDivider } from 'vuetify/lib'
import JcdcProgressLinear from '@/components/jcdc/JcdcProgressLinear.vue'

export default Vue.extend({
  name: 'JcdcSelect',
  components: {
    selectAll,
    VAutocomplete,
    VDivider,
    JcdcProgressLinear,
  },
  props: {
    defaultValue: {
      type: [Array, String, Number, Object],
      default: (): [] => [],
    },
    itemList: { type: Array as () => Array<string>, default: (): [] => [] },
    prependList: { type: Array as () => Array<string>, default: (): [] => [] },
    color: { type: String, default: 'primary' },
    label: { type: String, default: 'Select One' },
    hint: { type: String, default: null },
    dense: { type: Boolean, default: false },
    multiple: { type: Boolean, default: false },
    selectAll: { type: Boolean, default: false },
    required: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false },
    open: { type: Boolean, default: false },
    autoSelect: { type: Boolean, default: false },
    readonly: { type: Boolean, default: false },
  },
  data() {
    return {
      selected: this.defaultValue,
      selectRules: [
        (v: string | number) =>
          (v != '' && v != 0 && Boolean(v)) || `${this.label} is required`,
      ],
      menuProps: {
        allowOverflow: true,
        'offset-y': true,
        fixed: true,
      },
      testProps: {
        allowOverflow: true,
        'offset-y': true,
        fixed: true,
        value: true,
      },
      colorValue: this.color,
    }
  },
  computed: {
    computedList() {
      let computedList: string[]
      if (this.prependList != null) {
        computedList = this.prependList.concat(this.itemList)
      } else {
        computedList = this.itemList
      }
      return computedList
    },
    attachID() {
      return `_${Math.random().toString(36).substr(2, 9)}`
    },
    contentWidth(): number {
      if (this.$vuetify.breakpoint.xsOnly) return 31
      else if (this.itemList.length > 0) {
        let flattenedList = this.itemList
        // Flatten Object
        if (typeof this.itemList[0] === 'object') {
          flattenedList = []
          this.itemList.forEach((x) => {
            flattenedList = flattenedList.concat(Object.values(x))
          })
        }
        // Find Longest Value
        const longestValue = flattenedList.reduce((a, b) => {
          return a.length > b.length ? a : b
        })
        if (longestValue.length > 45) return 45
        return longestValue.length
      }
      return 20
    },
  },
  watch: {
    selected() {
      // Emit values
      this.$emit('change', this.selected)
    },
    defaultValue() {
      this.selected = this.defaultValue
    },
  },
  updated() {
    if (this.computedList.length === 1 && this.autoSelect) {
      this.selected = this.computedList[0]
    }
  },
  created() {
    if (this.computedList.length === 1 && this.autoSelect) {
      this.selected = this.computedList[0]
    }
  },
  methods: {
    onFocus() {
      this.readonlyHandler()
    },
    onBlur() {
      if (this.readonly) {
        this.colorValue = this.color
      }
    },
    readonlyHandler() {
      this.readonly
        ? (this.colorValue = 'error')
        : (this.colorValue = this.color)
    },
  },
})
